exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tc-accordion .acdn-title a[data-v-0fbfc738]:after {\n  right: auto !important;\n  font-weight: normal !important;\n}", ""]);

// exports
